const daysOfWeekOptions = [
  {
    id: 1,
    textDropDownEn: "-- Choose --",
  },

  {
    id: 2,
    textDropDownEn: "Monday",
  },

  {
    id: 3,
    textDropDownEn: "Tuesday",
  },
  {
    id: 4,
    textDropDownEn: "Wednesday",
  },

  {
    id: 5,
    textDropDownEn: "Thursday",
  },
  {
    id: 6,
    textDropDownEn: "Friday",
  },

  {
    id: 7,
    textDropDownEn: "Saturday",
  },
  {
    id: 8,
    textDropDownEn: "Sunday",
  },
];

export default daysOfWeekOptions;
